import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { getToken } from '@/libs/util'
const addErrorLog = errorInfo => {
  const { statusText, status, request: { responseURL } } = errorInfo
  let info = {
    type: 'ajax',
    code: status,
    mes: statusText,
    url: responseURL
  }
  if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
}

class HttpRequest {
  constructor (baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig () {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        token: getToken() || ''
      }
    }
    return config
  }
  destroy (url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors (instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      //清除参数的首位空格
      if(config.data){
        let data = config.data
        for(let key in data){
          if(typeof(data[key])=='string'){
            data[key] = data[key].trim();
          }else if(typeof(data[key])=='object'){
              let obj = data[key]
              for(let k in obj){
                if(typeof(obj[k])=='string'){
                  obj[k] = obj[k].trim();
                }
              }
          }
        }
      }else if(config.params){
        let params = config.params
        for(let key in params){
          if(typeof(params[key])=='string'){
            params[key] = params[key].trim();
          }
        }
      }
      this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)
      const { data, status } = res
      if(!getToken() && !data.token){
        console.log('Token失效跳转到登录界面')
        router.replace({
          name: 'login'
        });
        return { data, status };
      }
      return { data, status }
    }, error => {
      this.destroy(url)
      addErrorLog(error.response)
      return Promise.reject(error)
    })
  }
  request (options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest
